import { Injectable } from "@angular/core";
import { IConfiguration } from "src/app/_models/configuration/IConfiguration";
import { environment } from "src/environments/environment";
interface Scripts {
  name: string;
  src: string;
}
export const StylesStore: Scripts[] = [
  {
    name: "bootstrap",
    src: "assets/landing/vendor/bootstrap/css/bootstrap.min.css",
  },
  {
    name: "icofont",
    src: "assets/landing/vendor/icofont/icofont.min.css",
  },
  {
    name: "boxicons",
    src: "assets/landing/vendor/boxicons/css/boxicons.min.css",
  },
  {
    name: "carousel",
    src: "assets/landing/vendor/owl.carousel/assets/owl.carousel.min.css",
  },
  {
    name: "venobox",
    src: "assets/landing/vendor/venobox/venobox.css",
  },
  {
    name: "aos",
    src: "assets/landing/vendor/aos/aos.css",
  },
  {
    name: "style",
    src: "assets/landing/css/landing.css",
  },
];
export const ScriptStore: Scripts[] = [
  {
    name: "jquery",
    src: "assets/landing/vendor/jquery/jquery.min.js",
  },
  {
    name: "bootstrap",
    src: "assets/landing/vendor/bootstrap/js/bootstrap.bundle.min.js",
  },
  {
    name: "easing",
    src: "assets/landing/vendor/jquery.easing/jquery.easing.min.js",
  },
  {
    name: "carousel",
    src: "assets/landing/vendor/owl.carousel/owl.carousel.min.js",
  },
  {
    name: "venobox",
    src: "assets/landing/vendor/venobox/venobox.min.js",
  },
  {
    name: "aos",
    src: "assets/landing/vendor/aos/aos.js",
  },
  {
    name: "main",
    src: "assets/landing/js/landing.js",
  },
];
declare var document: any;
@Injectable()
export class DynamicScriptLoaderService {
  private styles: any = {};
  private scripts: any = {};
  configurations: IConfiguration[] = [];
  constructor() {
    localStorage.setItem("customPublicInterface", environment.customInterface ? "1" : "0");

    StylesStore.forEach((style: any) => {
      this.styles[style.name] = {
        loaded: false,
        src: style.src
      };
    });
    
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
  }
  loadS(...styles: string[]) {
    if (styles[0] == "style") {
      if (localStorage.getItem("customPublicInterface")) {
        if (localStorage.getItem("customPublicInterface") == "1") {
          this.styles["style"].src = "assets/landing/css/landing_custom.css";
        }
      }
    }
    
    const promises: any[] = [];
    styles.forEach((style) => promises.push(this.loadStyle(style)));
    return Promise.all(promises);
  }
  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }
  loadStyle(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.styles[name].loaded) {
        // load style
        const style = document.createElement('link');
        style.rel = 'stylesheet';
        style.href = this.styles[name].src;
        if (style.readyState) {
          // IE
          style.onreadystatechange = () => {
            if (
              style.readyState === "loaded" ||
              style.readyState === "complete"
            ) {
              style.onreadystatechange = null;
              this.styles[name].loaded = true;
              resolve({ style: name, loaded: true, status: "Loaded" });
            }
          };
        } else {
          // Others
          style.onload = () => {
            this.styles[name].loaded = true;
            resolve({ style: name, loaded: true, status: "Loaded" });
          };
        }
        style.onerror = (error: any) =>
          resolve({ script: name, loaded: false, status: "Loaded" });
        document.getElementsByTagName("head")[0].appendChild(style);
      } else {
        resolve({ style: name, loaded: true, status: "Already Loaded" });
      }
    });
  }
  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded) {
        // load script
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = this.scripts[name].src;
        if (script.readyState) {
          // IE
          script.onreadystatechange = () => {
            if (
              script.readyState === "loaded" ||
              script.readyState === "complete"
            ) {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: "Loaded" });
            }
          };
        } else {
          // Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: "Loaded" });
          };
        }
        script.onerror = (error: any) =>
          resolve({ script: name, loaded: false, status: "Loaded" });
        document.getElementsByTagName("head")[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: "Already Loaded" });
      }
    });
  }
}
